import { useClientConfig } from 'src/hooks/useClientConfig';

import './WidgetLogo.sass';

const WidgetLogo = () => {
	const client = useClientConfig();
	const backgroundImage = client?.image ? `url("${client?.image}")` : `${window?._env_?.HOST_URL ?? ''}/widget/default-logo.png`;
	return <div id="widget-logo" style={{ backgroundImage }} />;
};

export default WidgetLogo;
